import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=07b2dbf0&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"
import style0 from "./Product.vue?vue&type=style&index=0&id=07b2dbf0&prod&scoped=true&lang=css"
import style1 from "./Product.vue?vue&type=style&index=1&id=07b2dbf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b2dbf0",
  null
  
)

export default component.exports